"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ethereumjs_wallet_1 = require("ethereumjs-wallet");
const bip39_1 = require("bip39");
const enc_utils_1 = require("enc-utils");
const bn_js_1 = __importDefault(require("bn.js"));
const hash_js_1 = __importDefault(require("hash.js"));
const crypto_1 = require("./crypto");
function getIntFromBits(hex, start, end) {
    const bin = enc_utils_1.hexToBinary(hex);
    const bits = bin.slice(start, end);
    const i = enc_utils_1.binaryToNumber(bits);
    return i;
}
function getKeyPairFromPath(mnemonic, path) {
    const seed = bip39_1.mnemonicToSeedSync(mnemonic);
    const keySeed = ethereumjs_wallet_1.hdkey
        .fromMasterSeed(seed)
        .derivePath(path)
        .getWallet()
        .getPrivateKeyString();
    const starkEcOrder = crypto_1.ec.n;
    return crypto_1.ec.keyFromPrivate(grindKey(keySeed, starkEcOrder), 'hex');
}
exports.getKeyPairFromPath = getKeyPairFromPath;
function getAccountPath(layer, application, ethereumAddress, index) {
    const layerHash = hash_js_1.default
        .sha256()
        .update(layer)
        .digest('hex');
    const applicationHash = hash_js_1.default
        .sha256()
        .update(application)
        .digest('hex');
    const layerInt = getIntFromBits(layerHash, -31);
    const applicationInt = getIntFromBits(applicationHash, -31);
    const ethAddressInt1 = getIntFromBits(ethereumAddress, -31);
    const ethAddressInt2 = getIntFromBits(ethereumAddress, -62, -31);
    return `m/2645'/${layerInt}'/${applicationInt}'/${ethAddressInt1}'/${ethAddressInt2}'/${index}`;
}
exports.getAccountPath = getAccountPath;
function grindKey(keySeed, keyValLimit) {
    const sha256EcMaxDigest = new bn_js_1.default('1 00000000 00000000 00000000 00000000 00000000 00000000 00000000 00000000', 16);
    const maxAllowedVal = sha256EcMaxDigest.sub(sha256EcMaxDigest.mod(keyValLimit));
    let i = 0;
    let key = hashKeyWithIndex(keySeed, i);
    i++;
    while (!key.lt(maxAllowedVal)) {
        key = hashKeyWithIndex(keySeed, i);
        i++;
    }
    return key.umod(keyValLimit).toString('hex');
}
exports.grindKey = grindKey;
function hashKeyWithIndex(key, index) {
    return new bn_js_1.default(hash_js_1.default
        .sha256()
        .update(enc_utils_1.hexToBuffer(enc_utils_1.removeHexPrefix(key) + enc_utils_1.sanitizeBytes(enc_utils_1.numberToHex(index), 2)))
        .digest('hex'), 16);
}
exports.StarkExEc = crypto_1.ec.n;
function privateKeyFromSignature(signature) {
    const sig = crypto_1.deserializeSignature(signature);
    return grindKey(sig.r.toString('hex'), exports.StarkExEc);
}
exports.privateKeyFromSignature = privateKeyFromSignature;
//# sourceMappingURL=keyDerivation.js.map